/**
 * "Heading Size" rendering parameter (Sitecore value list: Default|Course Details Page).
 * Controls which heading size is applied to the heading level selected on a component.
 */
export const HEADING_SIZE_DEFAULT = 'Default';
export const HEADING_SIZE_COURSE_DETAILS = 'Course Details Page';

// Authors may see the option labelled "Course Details Page Template", so match on the prefix.
export const isCourseDetailsHeadingSize = (headingSize?: string): boolean =>
  typeof headingSize === 'string' &&
  headingSize.trim().toLowerCase().startsWith(HEADING_SIZE_COURSE_DETAILS.toLowerCase());
